import { fromJS }                       from 'immutable';
import numeral                          from 'numeral';
import { QUOTE_SUCCESS, QUOTE_FAILURE } from 'pu-redux/actions/QuoteActions';

const getLineItem = (quote) => {
  if (!quote && !quote.line_items && !quote.line_items[0]) return null;

  const lineItem = quote.line_items[0];
  if (lineItem.quantities && lineItem.lead_times && lineItem.pricing) {
    return lineItem;
  }
  return null;
};

const defaultState = fromJS({ unit_price: '', total_price: '', lead_time: ''});

const cartReducer = (state = defaultState, action) => {
  const { quote } = action;
  switch (action.type) {
    case QUOTE_SUCCESS: {
      const lineItem = getLineItem(quote);
      if (lineItem) {
        const quantity = lineItem.quantities[0];
        const leadTime = lineItem.lead_times[0];
        const { pricing } = lineItem;
        if (pricing !== undefined && pricing[0] !== undefined && pricing[0][0] !== undefined) {
          const unitPrice = parseFloat(pricing[0][0]) / parseFloat(quantity);
          return state.withMutations((st) => {
            st.set('unit_price', numeral(unitPrice * parseFloat(quantity)).format('$0,0.00'))
              .set('total_price', numeral(unitPrice).format('$0,0.00'))
              .set('lead_time', leadTime);
          });
        }
      }
      return state;
    }
    case QUOTE_FAILURE:
      return defaultState;

    default:
      return state;
  }
};

export default cartReducer;
